import React, { useRef } from 'react';
import { AppState } from 'core/redux/reducers';
import { selectActiveProductInfo } from 'core/redux/features/products/reducers/productInfos';
import { connect } from 'react-redux';
import { selectActiveProduct } from 'core/redux/features/products/reducers/products';
import ProductMapAddress from '../../Components/ProductMapAddress';
import cls from 'classnames';
// import { useTrans } from 'core/hooks';
// import { selectActiveProductType } from 'core/redux/features/products/reducers/productTypes'
// import { history } from 'core/redux/stores'
// import { selectViewTypeFilterOption } from 'core/redux/features/shared/reducers'
// import sharedActions from 'core/redux/features/shared/actions'

const mapDispatchToProps = {
  // onChangeView: sharedActions.changeView,
};
const mapStateToProps = (state: AppState) => {
  return {
    deviceType: state.deviceType,
    product: selectActiveProduct(state),
    info: selectActiveProductInfo(state),
    // viewTypes: selectViewTypeFilterOption(state),
    router: state.router,
  };
};

type PropType = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

export function Description(props: PropType) {
  const { product } = props;

  // const trans = useTrans();
  // const [expanded, setExpanded] = useState(true);
  const refDesc = useRef();
  const refDescWrap = useRef();

  // useEffect(() => {
  //   if (!refDesc.current || !refDescWrap.current) {
  //     return;
  //   }
  //
  //   let fullHeight = '';
  //   if (expanded) {
  //     fullHeight = height(refDesc.current, true) + 'px';
  //   }
  //
  //   addCss(refDescWrap.current, {
  //     maxHeight: fullHeight,
  //   });
  // }, [expanded]);

  // useEffect(() => {
  //   setExpanded(false);
  // }, [product.description]);

  if (!product) {
    return null;
  }

  return (
    <div className="content">
      {/*{info && info.youtube_video ? (*/}
      {/*  <VideoIframe alt={product.name} src={info.youtube_video} />*/}
      {/*) : null}*/}
      <div
        ref={refDescWrap}
        className={cls(
          'product_full_desc',
          'product_full_desc--open',
          // !expanded && 'product_full_desc--close',
          // expanded && 'product_full_desc--open',
        )}
      >
        <p
          ref={refDesc}
          dangerouslySetInnerHTML={{
            __html: product.description,
          }}
        />
        {/*<div*/}
        {/*  className={cls('product_full_desc__white_blur', expanded && 'hide')}*/}
        {/*/>*/}
      </div>
      {/*<div*/}
      {/*  className={cls('product_readmore', expanded && 'hide')}*/}
      {/*  onClick={e => {*/}
      {/*    e.preventDefault();*/}
      {/*    setExpanded(!expanded);*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <div className="product_readmore__icon" />*/}
      {/*  <div className="product_readmore__label">{trans('read_more')}</div>*/}
      {/*</div>*/}

      <ProductMapAddress mapOnly={true} />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Description);
